import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy Shopify-style URL — redirect to the canonical Chapter Vials product.
export const Route = createFileRoute("/products/discovery-sets")({
  beforeLoad: () => {
    throw redirect({
      to: "/products/$slug",
      params: { slug: "chapter-vials" },
      statusCode: 301,
    });
  },
});
